import { CircularProgress } from "@mui/material";
import { Fade, Logo } from ".";
import { purple } from "../config";

const Loading = () => {
  return (
    <div
      style={{
        textAlign: "center",
        flex: 1,
        background: purple[500],
        height: "-webkit-fill-available",
        width: "100vw",
        paddingTop: "20vh",
      }}
    >
      <Fade delay={100}>
        <Logo sm={false} />
        <CircularProgress color="secondary" style={{ marginTop: 18 }} />
      </Fade>
    </div>
  );
};

export default Loading;
